/**
 * Shared app defaults and magic-value constants.
 * Use these instead of scattering literals across the codebase.
 */

/** Default phone (Georgian) for forms: code, flag, empty number */
export const DEFAULT_PHONE = {
  code: "+995",
  flag: "🇬🇪",
  number: "",
};

/** Default pagination page size */
export const DEFAULT_PAGE_LIMIT = 20;

/** Options for "rows per page" selector in table/list views */
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

/** Breakpoint (px) below which table/list views are considered "mobile" (e.g. expandable rows) */
export const TABLE_MOBILE_BREAKPOINT = 1300;

/** Modal size values (match Modal.js: small, medium, large, xlarge, full) */
export const MODAL_SIZE = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge",
  FULL: "full",
};

/** Payment/invoice status: unpaid (used in filters, modals, defaults) */
export const PAYMENT_STATUS_UNPAID = "unpaid";

/**
 * Backend field name for bank account number (typo preserved for API compatibility).
 * Use this constant instead of the literal "bank_account_numbr" everywhere.
 */
export const BANK_ACCOUNT_NUMBER_FIELD = "bank_account_numbr";

/** Default currency symbol/code for display (override from company settings when available) */
export const DEFAULT_CURRENCY = "₾";
